import { render, staticRenderFns } from "./BookingReporting.vue?vue&type=template&id=27283bab&"
import script from "./BookingReporting.vue?vue&type=script&lang=js&"
export * from "./BookingReporting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports